import Link from "next/link";
import { useState } from "react";

const HirepageSmallButton = ({ button, link, label }) => {
  const { defaultColor, hover } = button;
  const [changeStyle, setChangeStyle] = useState(false);
  return (
    <Link href={link}>
      <a
        className="text-white font-semibold text-center border-0 rounded-lg md:rounded lg:rounded-lg text-lg md:text-sm lg:text-lg py-4 px-8 lg:px-10"
        href={link}
        style={
          changeStyle ? { background: hover } : { background: defaultColor }
        }
        onMouseEnter={() => setChangeStyle(true)}
        onMouseLeave={() => setChangeStyle(false)}
      >
        {label}
      </a>
    </Link>
  );
};

export default HirepageSmallButton;
